module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', [_c('v-card', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "pa-4": ""
    }
  }, [(_vm.message) ? _c('v-alert', {
    attrs: {
      "value": "message",
      "type": "success",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": "error",
      "type": "warning",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.error) + " ")])]) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "firstname",
      "label": "First Name",
      "rules": _vm.firstNameRules,
      "required": ""
    },
    model: {
      value: (_vm.user.firstName),
      callback: function($$v) {
        _vm.$set(_vm.user, "firstName", $$v)
      },
      expression: "user.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "lastname",
      "label": "Last Name",
      "rules": _vm.lastNameRules,
      "required": ""
    },
    model: {
      value: (_vm.user.lastName),
      callback: function($$v) {
        _vm.$set(_vm.user, "lastName", $$v)
      },
      expression: "user.lastName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "username",
      "label": "Username",
      "rules": _vm.userNameRules,
      "required": ""
    },
    model: {
      value: (_vm.user.username),
      callback: function($$v) {
        _vm.$set(_vm.user, "username", $$v)
      },
      expression: "user.username"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.roleNames,
      "label": "Role",
      "solo": "",
      "rules": _vm.roleRules,
      "required": ""
    },
    model: {
      value: (_vm.user.role),
      callback: function($$v) {
        _vm.$set(_vm.user, "role", $$v)
      },
      expression: "user.role"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.createInternalUser
    }
  }, [_vm._v("Create User")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12914f96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/createinternaluser.vue
// module id = 1039
// module chunks = 2